import React, { useMemo, useCallback } from 'react';
import { Select } from '@doxyme/ui';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { AccessLevel, } from '../../types';
import './access-dropdown.scss';
export const AccessDropdown = ({ accessLevel, document, handleChange, }) => {
    const intl = useIntl();
    const selectOptions = useMemo(() => [
        {
            label: intl.formatMessage({
                id: 'account.administration.teleconsent.access-level.only-you',
            }),
            value: AccessLevel.only,
        },
        {
            label: intl.formatMessage({
                id: 'account.administration.teleconsent.access-level.all-providers',
            }),
            value: AccessLevel.all,
        },
    ], [intl]);
    const { control } = useForm({
        mode: 'onChange',
        defaultValues: {
            accessLevel,
        },
    });
    const onChange = useCallback((value) => {
        handleChange(value, document);
    }, [document, handleChange]);
    return (<Select name="accessLevel" formGroupClassName="access-level-dropdown" data-testId="teleconsent-access-level" control={control} options={selectOptions} onChange={onChange}/>);
};
